/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CompletionSource {
  driver="driver",
location="location"
}

/**
* CompletionSource
*/
export const CompletionSourceEnumType = types.enumeration("CompletionSource", [
        "driver",
  "location",
      ])
